var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadingCircle = function SvgLoadingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#3B82F6",
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.7,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    from: "0 18 18",
    repeatCount: "indefinite",
    to: "360 18 18",
    type: "rotate"
  })))));
};
export default SvgLoadingCircle;